//
// Shop: Global events on change language
//

( function($, waTheme) {

    $(".js-lang-button").on("click", function() {
        var url = new URL(location.href);
        url.searchParams.append("locale", $(this).data("lang"));
        location.href = url.href;
    });

    // Change Language
    $(".js-lang-select").change(function () {
        var href = location.href,
            url = (href.indexOf('?') == -1) ? href += '?' : href += '&';
        location.href = url + 'locale=' + $(this).val();
    });

})(jQuery, window.waTheme);
